// extracted by mini-css-extract-plugin
export default {"investmentDrawer":"investmentDrawer","form":"form","mortgageLink":"mortgageLink"};